export default __webpack_public_path__ + "static/media/2350.8816e535.png";